<template>
		<div class="modal" v-show="visible == true">
			<div class="modal__background" @click="$modal.close(name)"></div>
			<div class="modal__content">
				<span @click='$modal.close(name)' class="close-btn"></span>

				<template v-if="title">
					<div class="modal__title">
						<h2>{{title}}</h2>
					</div>
				</template>

				<div class="modal__body">
					<slot></slot>
				</div>
				
				<template v-if="$slots['footer']">
					<div class="modal__footer">
						<slot name="footer"></slot>
					</div>
				</template>
				
			</div>
		</div>
</template>


<script>
	export default {
		props: ['name', "title"],
	  	name: 'modal',
	  	data () {
	  		return {
		  	}
		},
	  	created() {
	  		this.$modal.register(this.name);
	  	},
	  	computed: {
	  		visible() {
	  			return this.$modal.check(this.name);
	  		}
	  	}
	}

</script>


<style lang='scss'>

.modal {
	position: fixed;
	z-index: 10;
	top: 0px;
	left: 0px;
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	align-content: center;
	padding: 1em;
}

.modal .modal__background {
	position: absolute;
	top: 0px;
	left: 0px;
	width: 100%;
	height: 100%;
	background-color: rgba(0,0,0,0.4);
	z-index: 1;
}

.modal .modal__content {
	display: block;
	position: relative;
	background-color: white;
	color: $dark-grey;
	z-index: 2;
	padding: 0;
	
	max-width: 900px;
	text-align: center;
	width: calc(100% - 1em);
	min-width: 290px;
	/*width: 100%;*/
	max-height: calc(100% - 4em);
	overflow: auto;
	@include border-radius();

}

.modal .modal__content .modal__body {
	padding: 1.5em;
	text-align: left;
}

.modal .modal__content p {
	max-width: 400px;
}

.close-btn {
	position: absolute;
	top: 0.8em;
	right: 0.8em;
	width: 1.8em;
	height: 1.8em;
	border-radius: 100%;
	/*border: 1px solid rgba($dark-grey, 0.2);*/
	cursor: pointer;
}


.close-btn:after,
.close-btn:before {
	content: "";
	position: absolute;
	top: calc(0.9em - 2px);
	left: 0.4em;
	width: 1em;
	height: 2px;
	background-color: $dark-grey;
	border-radius: 2px;
	transform: rotate(45deg);
}

.close-btn:before {
	transform: rotate(-45deg);
}

.modal__footer {
	padding: 0em 1.5em 1em;
	text-align: right;
	/*border-top: 1px solid rgba($dark-grey, 0.1);*/
}


.modal__footer .stb-button {
	margin-left: 0.5em;
}
.modal__title {
	text-align: left;
	padding: 1em 1.5em;
	border-bottom: 1px solid rgba($dark-grey, 0.1);
}

</style>


// WEBPACK FOOTER //
// src/components/general/modal.vue